import {  _CSR_ACCESS_TOKEN } from '@/const/shopifyConst';
import { setCookie, getCookie, deleteCookie } from '@/utils/cookie'
const site = document.body.dataset.originalSite || 'us';
  import { shopifyConst } from '@/hooks/shopify-hooks/useShopifyConst.js';
  const { c4aOAuth2State} = shopifyConst;
const c4aOAuth2StateNew = c4aOAuth2State === 'true' ? true : false;

const COOKIE_DOMAIN = window.location.host;

export const useSetStorage = (key, value) => {
    const storageKey = site === 'us' ? key : `${key}_${site}`;
    if(_CSR_ACCESS_TOKEN === key && c4aOAuth2StateNew) {// 如果是新C4A登录方法，存取cookie
        //         host
// : 
// "uat.toshiba-lifestyle.com"
        setCookie(storageKey, JSON.stringify(value), { expires: 30, domain: COOKIE_DOMAIN })
        return
    }
    localStorage.setItem(storageKey, JSON.stringify(value));
}

export const useGetStorage = (key) => {
    const storageKey = site === 'us' ? key : `${key}_${site}`;
    let storage;
    console.log('----------token')
    if(_CSR_ACCESS_TOKEN === key && c4aOAuth2StateNew) { // 如果是新C4A登录方法，存取cookie
        storage = getCookie(storageKey)
        console.log('getCookie(storageKey)',storage,storageKey)
    }else {
        storage = localStorage.getItem(storageKey);
    }
    if (storage) {
        try {
            return JSON.parse(storage);
        } catch {
            return storage; // 如果不是 JSON，返回原始字符串
        }
    } else {
        return null;
    }
}

export const useRemoveStorage =  (key) => {
    const storageKey = site === 'us' ? key : `${key}_${site}`;
    if(_CSR_ACCESS_TOKEN === key && c4aOAuth2StateNew) {  // 如果是新C4A登录方法，存取cookie
        deleteCookie(storageKey, "/", COOKIE_DOMAIN)
    }
    localStorage.removeItem(storageKey);
}


export const useSetSessionStorage = (key, value) => {
    const storageKey = site === 'us' ? key : `${key}_${site}`;
    sessionStorage.setItem(storageKey, JSON.stringify(value));
}

export const useGetSessionStorage = (key) => {
    const storageKey = site === 'us' ? key : `${key}_${site}`;
    const storage = sessionStorage.getItem(storageKey);
    if (storage) {
        try {
            return JSON.parse(storage);
        } catch {
            return storage; // 如果不是 JSON，返回原始字符串
        }
    } else {
        return null;
    }
}

export const useRemoveSessionStorage =  (key) => {
    const storageKey = site === 'us' ? key : `${key}_${site}`;
    sessionStorage.removeItem(storageKey);
}